module.exports = {"id":true,"code":true,"requiredEvidence":true,"description":true,"lastOption":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/incidents/incidents.json
// module id = v3w1
// module chunks = 1